export default __webpack_public_path__ + "static/reverso-0b71138c8545532d70c84b45b27468ed.svg";